import { BookVisitStatus } from '@app/shared/enums/book-visit-status.enum';

export interface IBookVisitResult {
  status: BookVisitStatus;
  authenticationToken: string;
  visitId: string;
  paymentPageUrl: string;
}
